module.exports = __webpack_public_path__ + "img/fangan01.2ae1209c.jpeg";